import React from 'react';
const friendLinks = [{
  name: 'Geylang777.info',
  url: 'https://geylang777.info'
}, {
  name: 'Geylang666.me 芽笼666',
  url: 'https://geylang666.me'
}, {
  name: 'TTVIP',
  url: 'https://ttvip-62.site'
}, {
  name: 'SGHarem 新加坡后宫网',
  url: 'https://sgharem.site'
}, {
  name: 'SGLonelyGuy 新加坡寂寞男人',
  url: '#'
}, {
  name: 'SGBeautyCastle 新加坡美丽城堡',
  url: '#'
}, {
  name: '幸福缘 xfy1.net',
  url: 'https://xfy1.net'
}, {
  name: '幸福缘国际站 xfy8.com',
  url: 'https://xfy8.com'
}, {
  name: 'Shiok8 新加坡爽吧',
  url: 'https://shiok26.site'
}, {
  name: 'isyou.net 新加坡是您网',
  url: 'https://isyou.net'
}];
export function Footer() {
  return <footer className="bg-[#050508] border-t border-white/5 pt-16 pb-8 px-4 relative z-10" data-id="element-60">
      <div className="max-w-6xl mx-auto" data-id="element-61">
        {/* Top row: logo + nav links */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 mb-10" data-id="element-62">
          <div className="flex flex-col items-center md:items-start" data-id="element-63">
            <img src="https://cdn.magicpatterns.com/uploads/9kDESAf73B4fWLx8MEhe2j/escort.geylang666-20251016092455065674.png" alt="Geylang777 芽笼777 新加坡伴游平台 Logo" className="h-16 mb-4 object-contain opacity-80" data-id="element-64" />
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-red-500/50 text-red-500 text-xs font-bold mb-4" data-id="element-65">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-66" />
              仅限18岁以上成年人访问 (18+ ONLY)
            </div>
          </div>

          <div className="flex flex-wrap justify-center md:justify-end gap-6 text-sm text-gray-400" data-id="element-67">
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="hover:text-pink-primary transition-colors" data-id="element-68">
              Telegram频道
            </a>
            <a href="https://geylang777-4.site" target="_blank" rel="noopener noreferrer" className="hover:text-pink-primary transition-colors" data-id="element-69">
              官方网站
            </a>
            <a href="#" className="hover:text-pink-primary transition-colors" data-id="element-70">
              隐私政策
            </a>
            <a href="#" className="hover:text-pink-primary transition-colors" data-id="element-71">
              服务条款
            </a>
          </div>
        </div>

        {/* Friend links row */}
        <div className="border-t border-white/5 pt-8 mb-8" data-id="element-72">
          <p className="text-xs text-gray-500 mb-4 text-center md:text-left font-medium uppercase tracking-wider" data-id="element-73">
            友情链接 Partner Sites
          </p>
          <div className="flex flex-wrap justify-center md:justify-start gap-x-5 gap-y-2" data-id="element-74">
            {friendLinks.map((link, i) => <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" className="text-xs text-gray-500 hover:text-pink-primary transition-colors" data-id="element-75">
                {link.name}
              </a>)}
          </div>
        </div>

        {/* SEO keyword-rich paragraph */}
        <div className="border-t border-white/5 pt-8 mb-8" data-id="element-76">
          <p className="text-gray-600 text-xs leading-relaxed max-w-4xl" data-id="element-77">
            芽笼777（Geylang777）是新加坡领先的伴游信息服务平台，提供新加坡伴游、新加坡Escort、芽笼夜生活、Singapore
            Escort Service、Geylang
            Nightlife等全方位资讯。芽笼777与Geylang777.info、Geylang666.me、TTVIP（ttvip-62.site）、新加坡后宫网SGHarem（sgharem.site）、新加坡寂寞男人SGLonelyGuy、新加坡美丽城堡SGBeautyCastle、幸福缘xfy1.net、幸福缘国际站xfy8.com、新加坡爽吧Shiok8（shiok26.site）、新加坡是您网isyou.net等知名平台合作，共同服务新加坡及东南亚地区客户。关键词：新加坡伴游、Singapore
            Escort、Geylang777、芽笼伴游、新加坡夜生活、SG Escort
            Service、芽笼777伴游平台、新加坡高端伴游、Geylang
            Escort、新加坡陪伴服务、geylang777.info、geylang666.me、ttvip-62.site、sgharem.site、shiok26.site、xfy8.com、isyou.net。
          </p>
        </div>

        {/* Bottom row */}
        <div className="border-t border-white/5 pt-8 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-78">
          <p className="text-gray-500 text-xs max-w-2xl" data-id="element-79">
            免责声明：本平台仅提供信息展示服务，所有内容仅供成年人浏览。用户需遵守当地法律法规。
            Disclaimer: This platform only provides information display
            services. All content is for adults only. Users must comply with
            local laws and regulations.
          </p>
          <p className="text-gray-600 text-xs whitespace-nowrap" data-id="element-80">
            芽笼777 © {new Date().getFullYear()} All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}